import { useCallback, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { appointmentStatusesArchiveModalStateAtom } from './AppointmentStatusesArchive.state';

export function useAppointmentStatusesArchiveModal() {
  const setModalState = useSetRecoilState(
    appointmentStatusesArchiveModalStateAtom,
  );

  const openModal = useCallback(
    (params = { appointmentId: '', petSummary: {} }) => {
      console.log('🚀 ~ useAppointmentStatusesArchiveModal ~ params:', params);
      setModalState({ open: true, ...params });
    },
    [setModalState],
  );

  const closeModal = useCallback(() => {
    setModalState({ open: false });
  }, [setModalState]);

  return {
    openAppointmentStatusesArchiveModal: openModal,
    closeAppointmentStatusesArchiveModal: closeModal,
  };
}

export function useNestedModal() {
  const [modalData, setModalData] = useState({
    isOpen: false,
    record: null,
  });

  const open = (record) => {
    setModalData({
      isOpen: true,
      record,
    });
  };

  const close = () => {
    setModalData({
      isOpen: false,
      record: null,
    });
  };

  return {
    ...modalData,
    open,
    close,
  };
}
